<template>
	<div class="devicestatus">
		<div class="title">
			<img src="../../../assets/img/logo.png" alt="">
			<span>设备状态统计</span>
		</div>
		<div id="devicestatusecherts">
			
		</div>
	</div>
</template>

<script>
	import {EleResize} from '../../../esresize.js'
	export default {
	  name: "",
	  data() {
	  	return{
			date:[ {
			          value: 65,
			          name: "运行设备"
			        },
					{
			          value: 32,
			          name: "停机设备"
			        }, {
			          value: 12,
			          name: "故障设备"
			        },],
			all:0,
			colorarr:['#12b796','#ff932a','#27caff'],
		}
	  },
	  methods: {
	  fontSize(res,initWidth=1920){
		    	var nowClientWidth = document.documentElement.clientWidth;
		        return res*(nowClientWidth/initWidth);
			},
	  echartsLine(){
		   var echarts = require('echarts');
		   let energyConsumption = echarts.init(document.getElementById('devicestatusecherts'));
		    energyConsumption.off('legendselectchanged') 
		   energyConsumption.setOption({
			    legend: {
					orient: "vertical",
					align: "left",
					right: "0%",
					top: "10%",
					itemHeight:this.fontSize(15),
					itemWidth: this.fontSize(26),
					textStyle: {
					      color: "#FFFFFF",
						  fontSize:this.fontSize(13)
					},
					itemGap: this.fontSize(25),
					itemStyle: {
					      borderWidth: 0
					    },
					 inactiveBorderWidth:0
			      },
				  color:['#12b796','#ff932a','#27caff'],
			      series: [
				  {
			        type: "pie",
					clockwise: false,
					startAngle: 60,
					 // color:['#7ae8fb', '#04297a'],
					labelLine: {
					      show: true,
					      length: "3%",
					      length2: '5%',
						  minTurnAngle:90
					},
					
					label: {
						 textBorderWidth: 0,
						 formatter:(e)=>{
							// if(!this.colorarr.includes(e.color)){
							//  this.colorarr.push(e.color)
							//  this.ins++
							// }
							let data=e.data;
							if(e.color=='#12b796'){
								return  `{one|${(data.value/this.all*100).toFixed(2)}%}\n{name|${data.name}}`
							}else if(e.color=='#ff932a'){
								return  `{two|${(data.value/this.all*100).toFixed(2)}%}\n{name|${data.name}}`
							}else if(e.color=='#27caff'){
								return  `{three|${(data.value/this.all*100).toFixed(2)}%}\n{name|${data.name}}`
							}
							                                          
						  }, 
						 
						  
					      rich: {
							  name:{
								 color:'#FFFFFF',
								 fontSize: this.fontSize(12),
								 lineHeight: 20
							  },
							  one:{
								 color:'#12b796',
								 fontWeight: "bold",
								 fontSize: this.fontSize(14)
							  },
							  two:{
								 color:'#ff932a',
								 fontWeight: "bold",
								 fontSize: this.fontSize(14)
							  },
							  three:{
								 color:'#27caff',
								 fontWeight: "bold",
								 fontSize: this.fontSize(14)
							  },
					      },
					      
						  textBorderWidth: 0
						  
					    },
					itemStyle:{
						borderWidth:3,	//边框的宽度
						borderColor:'rgba(51, 82, 123, 1)'	//边框的颜色
					},
					center: ["40%", "50%"],
					radius: ["26%", "40%"],
			        data:this.date
			      },
				  {
				      type: "gauge",
					  center: ['40%', '50%'],
					  radius: "65%",
					  startAngle: 90,
					  endAngle: -270,
					  clockwise: true,
					  splitLine: {
					        show: true,
							length: '10%',
							lineStyle: {
								  color: "rgb(6, 174, 252)",
								  width:'2'
							  },
					      },
					 axisLine: {
					        show: false
					      },
					axisLabel: {
					      show: true,
					      distance:this.fontSize(-15) ,
						  color: "#999999",
						  formatter: function (value) {
							  if(value ==0){
								  return '0'
							  }else if(value ==25){
								  return '6'
							  }else if(value ==50){
								  return '8'
							  }else if(value ==75){
								  return '12'
							  }else{
								  
							  } 
						  },
						  fontSize:this.fontSize(12)
					    },
					 pointer: {
					       show: false
					     },
					title: {
					      show: true,
					      offsetCenter: ["0", "10%"],
					      color: "#ffffff",
						  fontSize: this.fontSize(12)
					    },
					detail: {
					      formatter: "{value}",
						  show: true,
						  color: "#fda851",
						  offsetCenter: ["0", "-10%"],
						  fontSize: this.fontSize(15)
					    },
					 axisTick: {
					       show: true,
					       splitNumber: 6,
						   length: '8%',
						   lineStyle: {
						           color: "rgb(6, 174, 252)",
								   
						    }
					     },
					 splitNumber: 12,
				      data: [{
							  value: this.all,
							  name: "设备总数"
					  }]
				   }  
				  ]
				 
		   });
		   window.addEventListener("resize", () => {
		    energyConsumption.resize();
		   });
		   energyConsumption.on('legendselectchanged',  (obj)=> {
			   this.allnum(obj.selected)
			   this.echartsLine();
		   })
		  
	   },
	   allnum(arr){
		   if(arr){
			   this.all=0
			   this.date.forEach((item,index) => {
			        if(arr[item.name]){
						this.all += Number(item.value);
					}
			   });
		   }else{
			   this.date.forEach((item) => {
			         this.all += Number(item.value);
			   });
		   }
	   },
	  },
	  
	  mounted() {
		  window.addEventListener("resize", () => {
		  	this.echartsLine();
		  });
		  
		 this.allnum()
	     this.echartsLine();
		 // var echarts = require('echarts');
		 // let energyConsumption = echarts.init(document.getElementById('devicestatusecherts'));
		
	  }
	};
</script>

<style scoped="scoped">
	.devicestatus{
		width: 100%;
		height: 38%;
	}
	#devicestatusecherts{
		width: 100%;
		height: calc(100% - 4vh);
		background: url(../../../assets/img/sgebeiqun.png) no-repeat;
		background-position: 33% 51%;
		background-size: 40% auto;
	}
</style>
